import $ from 'jquery'

$(function(){
	$(".disabled").on('click', function () {
  		return false;
	});
});